







import Vue from 'vue';
import BounceLoader from 'vue-spinner/src/BounceLoader.vue';

export default Vue.extend({
  props: ['loading', 'message'],
  components: {
    BounceLoader,
  },
});
